export const channels = [
  {
    id: 1,
    name: "VR Media Network",
    category: "Entertainment",
    accentColor: "vr-red",
    accentColorHex: "#FF2C2C",
    subscribers: "Loading...",
    youtubeUsername: "VRMediaNetwork.Official",
    description: "VR Media India's main entertainment channel featuring latest cinema updates, celebrity interviews 2025, travel vlogs, and lifestyle trends. Your premier destination for entertainment news and public opinions in India.",
    youtubeUrl: "https://www.youtube.com/@VRMediaNetwork.Official",
    logo: "/VRM Logo PNG.png",
    banner: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    latestVideo: null, // Will be populated by API
    content: [
      "Latest cinema updates and movie news",
      "Exclusive celebrity interviews 2025",
      "Travel vlogs and lifestyle content",
      "Public opinions and entertainment discussions"
    ]
  },
  {
    id: 2,
    name: "VR Religious",
    category: "Spirituality",
    accentColor: "vr-red",
    accentColorHex: "#FF2C2C",
    subscribers: "2.53K",
    youtubeUsername: "vrreligious",
    description: "Spiritual content, religious teachings, and faith-based discussions that inspire and uplift.",
    youtubeUrl: "https://www.youtube.com/@vrreligious",
    logo: "/vrreligious.jpg",
    banner: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    latestVideo: null, // Will be populated by API
    content: [
      "Daily prayers and meditations",
      "Religious teachings and sermons",
      "Faith-based lifestyle content",
      "Community discussions"
    ]
  },
  {
    id: 3,
    name: "VR Kitchen",
    category: "Cooking",
    accentColor: "vr-yellow",
    accentColorHex: "#FFB400",
    subscribers: "1.54K",
    youtubeUsername: "vrkitchenchannel",
    description: "Delicious recipes, cooking tutorials, and culinary adventures for food lovers.",
    youtubeUrl: "https://www.youtube.com/@vrkitchenchannel",
    logo: "/vrkitchen.jpg",
    banner: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    latestVideo: null, // Will be populated by API
    content: [
      "Easy-to-follow recipes",
      "Cooking tips and techniques",
      "Kitchen equipment reviews",
      "Food challenges and experiments"
    ]
  },
  {
    id: 4,
    name: "VR Short Stories",
    category: "Storytelling",
    accentColor: "vr-pink",
    accentColorHex: "#FF5E78",
    subscribers: "1.7K",
    youtubeUsername: "vrshortstories",
    description: "Captivating short stories, creative narratives, and imaginative content for story lovers.",
    youtubeUrl: "https://www.youtube.com/@vrshortstories",
    logo: "/vrshortstories.jpg",
    banner: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    latestVideo: null, // Will be populated by API
    content: [
      "Original short stories",
      "Storytelling techniques",
      "Creative writing tips",
      "Interactive story sessions"
    ]
  },
  {
    id: 5,
    name: "VR Wellness",
    category: "Wellness",
    accentColor: "vr-blue",
    accentColorHex: "#6BE0C7",
    subscribers: "128",
    youtubeUsername: "vrwellnesschannel",
    description: "Health, fitness, and wellness content to help you live your best life.",
    youtubeUrl: "https://www.youtube.com/@vrwellnesschannel",
    logo: "/vrwellness.jpg",
    banner: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    latestVideo: null, // Will be populated by API
    content: [
      "Workout routines",
      "Mental health tips",
      "Nutrition advice",
      "Meditation and mindfulness"
    ]
  }
];

export const getChannelByAccentColor = (accentColor) => {
  return channels.find(channel => channel.accentColor === accentColor);
};

export const updateChannelSubscribers = (channelStats) => {
  return channels.map(channel => {
    const stats = channelStats[channel.name];
    if (stats) {
      return {
        ...channel,
        subscribers: stats.formattedSubscribers,
        subscriberCount: stats.subscriberCount,
        videoCount: stats.videoCount,
        viewCount: stats.viewCount,
        latestVideo: stats.latestVideo || null // Keep the full latestVideo object
      };
    }
    return channel;
  });
};
